import { render, staticRenderFns } from "./IconDocumentSolid.vue?vue&type=template&id=f6bccf92"
import script from "./IconDocumentSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports